module.exports = __webpack_public_path__ + "static/guard_drake_blue-390e86368cc6193df221af77dfaef199.jpeg";